import { Card, CardContent, CardHeader } from '@/app/common/components/Card'
import Image from '@/app/common/components/Image'
import { ProviderDetail } from '@/schemas/provider.schema'

type Props = {
  affiliations?: ProviderDetail['affiliations']
}

const AffiliationsCard = ({ affiliations }: Props) => {
  const providerAffiliations = affiliations ?? []

  return (
    <Card className="w-full">
      <CardHeader className="py-4 font-semibold text-lg">
        Affiliations
      </CardHeader>

      <CardContent className="py-4">
        {providerAffiliations.length === 0 ? (
          <p className="text-sm text-gray-600">
            Provider is not associated with any affiliation.
          </p>
        ) : (
          <div className="grid gap-3 sm:grid-cols-2">
            {providerAffiliations.map((affiliation) => (
              <div
                key={affiliation.id}
                className="flex items-center gap-3 rounded-lg border border-gray-200 p-3"
              >
                <div className="shrink-0">
                  {affiliation.logo ? (
                    <Image
                      path={affiliation.logo}
                      alt={affiliation.name}
                      allowZoom={false}
                      className="h-16 w-16 rounded-lg border border-gray-200 object-cover"
                    />
                  ) : (
                    <div className="flex h-16 w-16 items-center justify-center rounded-lg border border-gray-200 bg-gray-100 px-1 text-center text-xs font-medium leading-tight text-gray-500">
                      No Logo
                    </div>
                  )}
                </div>

                <div className="min-w-0 flex-1">
                  <p
                    className="truncate text-sm font-medium text-gray-900"
                    title={affiliation.name}
                  >
                    {affiliation.name}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  )
}

export default AffiliationsCard
